<template>
  <div class="requirement-rating" v-if="rating">
    <p v-if="title"><strong>{{ title }}:</strong></p>
    <div class="requirement-rating-icons">
      <i v-for="index in 5" :key="index" class="icon icon-wanderer-large"></i>
    </div>
    <div class="requirement-rating-icons-overlay">
      <i v-for="index in parseInt(rating)" :key="index" class="icon icon-wanderer-large"></i>
      <i v-if="hasHalfRating" class="icon icon-wanderer-large-half"></i>
    </div>
  </div>
</template>
<style></style>
<script>
export default {
  name: "requirement-rating",
  props: {
    title: String,
    rating: [ Number, Boolean ],
  },
  data: function () {
    return {

    }
  },
  computed: {
    hasHalfRating: function(){
      return (parseFloat(this.rating) % 1 >= 0.5);
    }
  }
}
</script>
